//储存 data数据
export function objData() {
    let data = {
        objInfo: {}, //报告详情
        nRooms: false, //是否楼层弹窗
        bConfirmPopupShow: false, //删除弹窗显示
        arrNum: [], //温度数组
        arrRate: [
            { value: 70 },
            { value: 75 },
            { value: 80 },
            { value: 85 },
            { value: 90 },
            { value: 95 },
            { value: 100 },
        ], //同开率数组
        arrWindNum: [{ value: 0.5 }, { value: 1 }, { value: 1.5 }], //换风数组
        arrAnchor: [{ value: 20 }], //温度默认选中值
        arrAnchorRate: [{ value: 80 }], //同开率默认选中值
        arrAnchorWind: [{ value: 1 }], //换风次数默认选中值
        oPicker: {
            colorConfirm: "rgba(33, 51, 102, 1)",
        }, //picker 插件配置
        oProduct: {}, //当前选择分类
        bChangeRate: false, //是否为更新同开率
        oGoodsInfo: {}, //产品选择弹窗接受数据
        arrPre: [], //楼层选型数据
        nRate: "", //同开率
        arrSelectList: [], //分类
        bSearchModalShow: false, //产品单选弹窗显示
        bSearchModalShow2: false, //产品多选弹窗显示
        bEditMore: false, //是否为修改多个
        sTypeTitle: "", //修改类型名
        findex: 0,
        pindex: 0,
        gindex: 0,
        isAdd: false, //是否为新增
        oPickWindNum: {}, //当前修改换风次数的对象
        arrPGoods: [], //当前操作分类下的商品
        nPIndex: 0, //当前操作分类的索引
        bDelCate: false, //是否为删除分类
        sDelTips: "", //删除提示
        oPit: {}, //当前操作分类
        nGindex: 0, //当前操作分类下的商品索引
        bDelGood: false, //是否为删除商品
        nWindExchange: 1, //换风次数默认为1
        bChangeWind: false, //是否为更新换风次数
        bHotWaterFlow: false, // 是否为修改热水设计流量
        nWaterRate: null, //热水设计流量
        arrPower: [], //楼层同开率
        nFindex: 0, //楼层索引
    }
    return data
}